:host {
  display: contents;

  br-item {
    box-shadow: var(--skiplink-shadow);
    display: inline-flex;
    min-width: var(--skiplink-min-width);
    position: absolute;
    top: -100vh;
    transition: top var(--skiplink-duration) var(--skiplink-timing-function);
    white-space: nowrap;
    width: auto;

    &:focus-within {
      top: 0;
    }
  }
}

:host(.compound-mode) {
  br-item {
    box-shadow: none;
    min-width: 0;
    position: relative;
    top: 0;
  }
}
